// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 78 hooks for backend/fleet.

import { useBackend } from '../useBackend'

/** POST /api/fleet/addIncidentUpdate */
export function useAddIncidentUpdate<T = any>() {
  return useBackend<T>('fleet/addIncidentUpdate')
}

/** POST /api/fleet/addVehicleUpdate */
export function useAddVehicleUpdate<T = any>() {
  return useBackend<T>('fleet/addVehicleUpdate')
}

/** POST /api/fleet/allocateDriverToSeat */
export function useAllocateDriverToSeat<T = any>() {
  return useBackend<T>('fleet/allocateDriverToSeat')
}

/** POST /api/fleet/attachIncidentEvidence */
export function useAttachIncidentEvidence<T = any>() {
  return useBackend<T>('fleet/attachIncidentEvidence')
}

/** POST /api/fleet/benchDriverFromSeat */
export function useBenchDriverFromSeat<T = any>() {
  return useBackend<T>('fleet/benchDriverFromSeat')
}

/** POST /api/fleet/benchDriverWithCause */
export function useBenchDriverWithCause<T = any>() {
  return useBackend<T>('fleet/benchDriverWithCause')
}

/** POST /api/fleet/bulkEditVehicles */
export function useBulkEditVehicles<T = any>() {
  return useBackend<T>('fleet/bulkEditVehicles')
}

/** POST /api/fleet/bulkUpdateVehicles */
export function useBulkUpdateVehicles<T = any>() {
  return useBackend<T>('fleet/bulkUpdateVehicles')
}

/** POST /api/fleet/cancelServiceBooking */
export function useCancelServiceBooking<T = any>() {
  return useBackend<T>('fleet/cancelServiceBooking')
}

/** POST /api/fleet/captureServiceBooking */
export function useCaptureServiceBooking<T = any>() {
  return useBackend<T>('fleet/captureServiceBooking')
}

/** POST /api/fleet/countRepairAsService */
export function useCountRepairAsService<T = any>() {
  return useBackend<T>('fleet/countRepairAsService')
}

/** POST /api/fleet/deleteMaintenanceLine */
export function useDeleteMaintenanceLine<T = any>() {
  return useBackend<T>('fleet/deleteMaintenanceLine')
}

/** POST /api/fleet/dismissServiceCandidate */
export function useDismissServiceCandidate<T = any>() {
  return useBackend<T>('fleet/dismissServiceCandidate')
}

/** POST /api/fleet/generateAllocation */
export function useGenerateAllocation<T = any>() {
  return useBackend<T>('fleet/generateAllocation')
}

/** POST /api/fleet/getAllocationBench */
export function useGetAllocationBench<T = any>() {
  return useBackend<T>('fleet/getAllocationBench')
}

/** POST /api/fleet/getAllocationCurrent */
export function useGetAllocationCurrent<T = any>() {
  return useBackend<T>('fleet/getAllocationCurrent')
}

/** POST /api/fleet/getAllocationIneligibleSeated */
export function useGetAllocationIneligibleSeated<T = any>() {
  return useBackend<T>('fleet/getAllocationIneligibleSeated')
}

/** POST /api/fleet/getAllocationSeatChanges */
export function useGetAllocationSeatChanges<T = any>() {
  return useBackend<T>('fleet/getAllocationSeatChanges')
}

/** POST /api/fleet/getComplianceExpiries */
export function useGetComplianceExpiries<T = any>() {
  return useBackend<T>('fleet/getComplianceExpiries')
}

/** POST /api/fleet/getEligibleDriversForAllocation */
export function useGetEligibleDriversForAllocation<T = any>() {
  return useBackend<T>('fleet/getEligibleDriversForAllocation')
}

/** POST /api/fleet/getFleet */
export function useGetFleet<T = any>() {
  return useBackend<T>('fleet/getFleet')
}

/** POST /api/fleet/getIncidentEvidence */
export function useGetIncidentEvidence<T = any>() {
  return useBackend<T>('fleet/getIncidentEvidence')
}

/** POST /api/fleet/getIncidentFormOptions */
export function useGetIncidentFormOptions<T = any>() {
  return useBackend<T>('fleet/getIncidentFormOptions')
}

/** POST /api/fleet/getIncidentTimeline */
export function useGetIncidentTimeline<T = any>() {
  return useBackend<T>('fleet/getIncidentTimeline')
}

/** POST /api/fleet/getIncidentUpdates */
export function useGetIncidentUpdates<T = any>() {
  return useBackend<T>('fleet/getIncidentUpdates')
}

/** POST /api/fleet/getLiveFleet */
export function useGetLiveFleet<T = any>() {
  return useBackend<T>('fleet/getLiveFleet')
}

/** POST /api/fleet/getMaintenanceBreakdown */
export function useGetMaintenanceBreakdown<T = any>() {
  return useBackend<T>('fleet/getMaintenanceBreakdown')
}

/** POST /api/fleet/getMaintenanceInvoiceUrl */
export function useGetMaintenanceInvoiceUrl<T = any>() {
  return useBackend<T>('fleet/getMaintenanceInvoiceUrl')
}

/** POST /api/fleet/getMaintenanceLineDriverOptions */
export function useGetMaintenanceLineDriverOptions<T = any>() {
  return useBackend<T>('fleet/getMaintenanceLineDriverOptions')
}

/** POST /api/fleet/getMaintenanceLines */
export function useGetMaintenanceLines<T = any>() {
  return useBackend<T>('fleet/getMaintenanceLines')
}

/** POST /api/fleet/getMaintenanceMonths */
export function useGetMaintenanceMonths<T = any>() {
  return useBackend<T>('fleet/getMaintenanceMonths')
}

/** POST /api/fleet/getMaintenanceTickets */
export function useGetMaintenanceTickets<T = any>() {
  return useBackend<T>('fleet/getMaintenanceTickets')
}

/** POST /api/fleet/getManagerBookBalance */
export function useGetManagerBookBalance<T = any>() {
  return useBackend<T>('fleet/getManagerBookBalance')
}

/** POST /api/fleet/getOffRoadVehicles */
export function useGetOffRoadVehicles<T = any>() {
  return useBackend<T>('fleet/getOffRoadVehicles')
}

/** POST /api/fleet/getServiceAddressMatches */
export function useGetServiceAddressMatches<T = any>() {
  return useBackend<T>('fleet/getServiceAddressMatches')
}

/** POST /api/fleet/getServiceAddressPlace */
export function useGetServiceAddressPlace<T = any>() {
  return useBackend<T>('fleet/getServiceAddressPlace')
}

/** POST /api/fleet/getServiceBoard */
export function useGetServiceBoard<T = any>() {
  return useBackend<T>('fleet/getServiceBoard')
}

/** POST /api/fleet/getServiceBookings */
export function useGetServiceBookings<T = any>() {
  return useBackend<T>('fleet/getServiceBookings')
}

/** POST /api/fleet/getServiceDayDriver */
export function useGetServiceDayDriver<T = any>() {
  return useBackend<T>('fleet/getServiceDayDriver')
}

/** POST /api/fleet/getServiceRepairCandidates */
export function useGetServiceRepairCandidates<T = any>() {
  return useBackend<T>('fleet/getServiceRepairCandidates')
}

/** POST /api/fleet/getServiceStampPhotos */
export function useGetServiceStampPhotos<T = any>() {
  return useBackend<T>('fleet/getServiceStampPhotos')
}

/** POST /api/fleet/getVehicleAllocation */
export function useGetVehicleAllocation<T = any>() {
  return useBackend<T>('fleet/getVehicleAllocation')
}

/** POST /api/fleet/getVehicleAllocationExceptions */
export function useGetVehicleAllocationExceptions<T = any>() {
  return useBackend<T>('fleet/getVehicleAllocationExceptions')
}

/** POST /api/fleet/getVehicleDamageRegister */
export function useGetVehicleDamageRegister<T = any>() {
  return useBackend<T>('fleet/getVehicleDamageRegister')
}

/** POST /api/fleet/getVehicleDocuments */
export function useGetVehicleDocuments<T = any>() {
  return useBackend<T>('fleet/getVehicleDocuments')
}

/** POST /api/fleet/getVehicleExpiryDetail */
export function useGetVehicleExpiryDetail<T = any>() {
  return useBackend<T>('fleet/getVehicleExpiryDetail')
}

/** POST /api/fleet/getVehicleIncidentCards */
export function useGetVehicleIncidentCards<T = any>() {
  return useBackend<T>('fleet/getVehicleIncidentCards')
}

/** POST /api/fleet/getVehicleIncidents */
export function useGetVehicleIncidents<T = any>() {
  return useBackend<T>('fleet/getVehicleIncidents')
}

/** POST /api/fleet/getVehicleManagerBook */
export function useGetVehicleManagerBook<T = any>() {
  return useBackend<T>('fleet/getVehicleManagerBook')
}

/** POST /api/fleet/linkMaintenanceInvoiceLines */
export function useLinkMaintenanceInvoiceLines<T = any>() {
  return useBackend<T>('fleet/linkMaintenanceInvoiceLines')
}

/** POST /api/fleet/moveAllocationSeat */
export function useMoveAllocationSeat<T = any>() {
  return useBackend<T>('fleet/moveAllocationSeat')
}

/** POST /api/fleet/moveMaintenanceLine */
export function useMoveMaintenanceLine<T = any>() {
  return useBackend<T>('fleet/moveMaintenanceLine')
}

/** POST /api/fleet/openMaintenanceTicket */
export function useOpenMaintenanceTicket<T = any>() {
  return useBackend<T>('fleet/openMaintenanceTicket')
}

/** POST /api/fleet/openServiceStamp */
export function useOpenServiceStamp<T = any>() {
  return useBackend<T>('fleet/openServiceStamp')
}

/** POST /api/fleet/pollCameraStream */
export function usePollCameraStream<T = any>() {
  return useBackend<T>('fleet/pollCameraStream')
}

/** POST /api/fleet/readMaintenanceInvoice */
export function useReadMaintenanceInvoice<T = any>() {
  return useBackend<T>('fleet/readMaintenanceInvoice')
}

/** POST /api/fleet/recordIncident */
export function useRecordIncident<T = any>() {
  return useBackend<T>('fleet/recordIncident')
}

/** POST /api/fleet/recordLastService */
export function useRecordLastService<T = any>() {
  return useBackend<T>('fleet/recordLastService')
}

/** POST /api/fleet/recordMaintenanceLine */
export function useRecordMaintenanceLine<T = any>() {
  return useBackend<T>('fleet/recordMaintenanceLine')
}

/** POST /api/fleet/recordOdometerReading */
export function useRecordOdometerReading<T = any>() {
  return useBackend<T>('fleet/recordOdometerReading')
}

/** POST /api/fleet/recordServiceStamp */
export function useRecordServiceStamp<T = any>() {
  return useBackend<T>('fleet/recordServiceStamp')
}

/** POST /api/fleet/releaseDriverBench */
export function useReleaseDriverBench<T = any>() {
  return useBackend<T>('fleet/releaseDriverBench')
}

/** POST /api/fleet/resolveMaintenanceInvoiceItem */
export function useResolveMaintenanceInvoiceItem<T = any>() {
  return useBackend<T>('fleet/resolveMaintenanceInvoiceItem')
}

/** POST /api/fleet/returnVehicleToRoad */
export function useReturnVehicleToRoad<T = any>() {
  return useBackend<T>('fleet/returnVehicleToRoad')
}

/** POST /api/fleet/setMaintenanceLineBorne */
export function useSetMaintenanceLineBorne<T = any>() {
  return useBackend<T>('fleet/setMaintenanceLineBorne')
}

/** POST /api/fleet/setMaintenanceLineDate */
export function useSetMaintenanceLineDate<T = any>() {
  return useBackend<T>('fleet/setMaintenanceLineDate')
}

/** POST /api/fleet/setMaintenanceTicketStatus */
export function useSetMaintenanceTicketStatus<T = any>() {
  return useBackend<T>('fleet/setMaintenanceTicketStatus')
}

/** POST /api/fleet/setVehicleExpiry */
export function useSetVehicleExpiry<T = any>() {
  return useBackend<T>('fleet/setVehicleExpiry')
}

/** POST /api/fleet/setVehicleManager */
export function useSetVehicleManager<T = any>() {
  return useBackend<T>('fleet/setVehicleManager')
}

/** POST /api/fleet/setVehicleOffRoad */
export function useSetVehicleOffRoad<T = any>() {
  return useBackend<T>('fleet/setVehicleOffRoad')
}

/** POST /api/fleet/signServiceStampUpload */
export function useSignServiceStampUpload<T = any>() {
  return useBackend<T>('fleet/signServiceStampUpload')
}

/** POST /api/fleet/splitMaintenanceLine */
export function useSplitMaintenanceLine<T = any>() {
  return useBackend<T>('fleet/splitMaintenanceLine')
}

/** POST /api/fleet/startCameraStream */
export function useStartCameraStream<T = any>() {
  return useBackend<T>('fleet/startCameraStream')
}

/** POST /api/fleet/swapAllocationVehicles */
export function useSwapAllocationVehicles<T = any>() {
  return useBackend<T>('fleet/swapAllocationVehicles')
}

/** POST /api/fleet/updateIncident */
export function useUpdateIncident<T = any>() {
  return useBackend<T>('fleet/updateIncident')
}

/** POST /api/fleet/updateOffRoadPeriod */
export function useUpdateOffRoadPeriod<T = any>() {
  return useBackend<T>('fleet/updateOffRoadPeriod')
}

/** POST /api/fleet/updateVehicle */
export function useUpdateVehicle<T = any>() {
  return useBackend<T>('fleet/updateVehicle')
}

/** POST /api/fleet/uploadMaintenanceInvoice */
export function useUploadMaintenanceInvoice<T = any>() {
  return useBackend<T>('fleet/uploadMaintenanceInvoice')
}
